export default __webpack_public_path__ + "static/20-50694bf6939aa74b9c855422653eb302.jpg";